import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sign-out')({
  ssr: false,
});
